import React from 'react';
import { motion } from 'framer-motion';
import { RadiantStar } from './ui/RadiantStar';
export function WelcomeSection() {
  return <section className="relative py-24 overflow-hidden" data-id="element-214" data-mp="12xjhayr3gq8h">
      {/* Decorative Star */}
      <div className="absolute top-10 right-10 opacity-60 pointer-events-none hidden md:block" data-id="element-215" data-mp="p5v56vgui1ri">
        <RadiantStar size={48} delay={0.5} data-id="element-216" data-mp="u4porzmmzuco" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-217" data-mp="f8gqb0akll1b">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-218" data-mp="f75ov74lkpdd">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-219" data-mp="k8mj4jsktdkz">
            <h2 className="font-serif text-4xl md:text-5xl text-gold-400 mb-6" data-id="element-220" data-mp="20jyxlx7sbhug">
              This is where your next adventure begins
            </h2>

            <div className="space-y-6 text-cream-50/90 text-lg leading-relaxed" data-id="element-221" data-mp="n7yvincw1n7w">
              <p data-id="element-222" data-mp="j7ydytuhsvwm">
                We support individuals who feel overwhelmed, stuck, or at a
                crossroads.
              </p>
              <p data-id="element-223" data-mp="wybl4tzk86kw">
                Modern life constantly pulls us toward expectations, pressure,
                endless choices, social media, and FOMO, leaving little space to
                reflect on what truly matters to you.
              </p>
              <p data-id="element-224" data-mp="92nntlr91o2">
                Through partnership-based coaching, we help you slow down,
                regain clarity, and reconnect with the direction that feels
                right for you.
              </p>
              <p data-id="element-225" data-mp="98zeo1vmacma">
                Our 4-step coaching journey combines reflection, future focus,
                and practical action to help you make confident decisions and
                build a life that truly feels like yours.
              </p>

              {/* Closing quote-like statement */}
              <div className="pt-4 border-l-2 border-gold-400/50 pl-5" data-id="element-226" data-mp="1so29gelohng9">
                <p className="font-serif italic text-xl md:text-2xl text-cream-50 leading-relaxed" data-id="element-227" data-mp="1wqfef0slphbz">
                  Because true transformation is not about changing who you are.
                  It's about remembering who you've always been.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-228" data-mp="1925xoda8vjrp">
            <div className="absolute inset-0 bg-gold-400/20 rounded-lg transform rotate-3" data-id="element-229" data-mp="qb4x5kth7g61"></div>
            <img src="https://cdn.magicpatterns.com/uploads/hkHEmTH4JHdibv3c59UUah/Panoramic_Composition_Of_Baobab_Trees_Along_Baobab_Alley_At_Sunset_Near_Morondava,_Madagascar_dreamstime_xxl_129751562_(1).jpg" alt="Avenue of Baobab trees at sunset in Madagascar" className="relative rounded-lg shadow-2xl w-full h-auto object-cover aspect-[4/3]" data-id="element-230" data-mp="v96fg3j2vbgg" />
          </motion.div>
        </div>
      </div>
    </section>;
}